<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-mapeamento
      :fim="mapeamento.fimPerComportServidor"
      :inicio="mapeamento.inicioPerComportServidor"
      acesso="COMUM"
      titulo="Competências Comportamentais"
    >
      <template v-slot:body>
        <v-col v-if="usuarioMapeamento.tipo != 'REGULAR'">
          <info-dispensa
            :mensagem="`Usuário não realiza cadastro de comportamento.`"
          />
        </v-col>
        <v-col v-else-if="mapeamento.mapeamentoImportado && loaded">
          <app-alert
            type="info"
            :message="`Mapeamento importado através do mapeamento (${mapeamento.mapeamentoImportado.nome})`"
          />
        </v-col>
        <v-row
          v-if="
            (prazoAtual || prazoEsgotado) && usuarioMapeamento.tipo == 'REGULAR'
          "
          no-gutters
        >
          <v-col>
            <v-tabs
              v-model="categoria"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="c in categorias"
                :key="c.id"
                :href="'#' + c.id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{ c.descricao }}</span>
                <v-badge
                  :color="c.id === categoria ? 'secondary' : 'grey'"
                  :content="getTotalComportamentos(c.id)"
                >
                  <v-icon :color="c.id === categoria ? 'secondary' : 'grey'">
                    {{ c.icone }}
                  </v-icon>
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="categoria">
              <v-tab-item
                v-for="c in categorias"
                :key="c.id"
                :value="c.id"
                class="mt-6"
              >
                <v-row
                  v-if="prazoAtual"
                  no-gutters
                >
                  <v-col>
                    <v-text-field
                      :ref="c.id"
                      v-model.trim="comportamento.descricao"
                      :label="isEditando ? 'Edite sua resposta' : frase"
                      @keyup.enter="salvar"
                    />
                  </v-col>
                </v-row>
                <v-row
                  v-if="prazoAtual"
                  no-gutters
                >
                  <v-spacer />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div
                        class="right mr-2"
                        v-on="on"
                      >
                        <v-btn
                          :disabled="comportamento.descricao === ''"
                          color="primary"
                          depressed
                          medium
                          @click="salvar"
                        >
                          {{ isEditando ? "Editar" : "Adicionar" }}
                        </v-btn>
                      </div>
                    </template>
                    <span>{{
                      isEditando
                        ? 'Clique no botão para editar o comportamento'
                        : 'Clique no botão para adicionar um comportamento'
                    }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div
                        class=""
                        v-on="on"
                      >
                        <v-btn
                          :disabled="comportamento.descricao === ''"
                          color="primary"
                          outlined
                          @click="clearFields()"
                        >
                          Cancelar
                        </v-btn>
                      </div>
                    </template>
                    <span>Clique no botão para cancelar a operação</span>
                  </v-tooltip>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-data-table
                      :headers="headers"
                      :items="comportamentos"
                      class="elevation-0 mt-4"
                    >
                      <template v-slot:[`item.acoes`]="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-spacer />
                            <v-btn
                              v-if="prazoAtual"
                              class="mr-2"
                              color="secondary"
                              icon
                              small
                              @click="prepararEdicao(item)"
                              v-on="on"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para editar o comportamento</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-if="prazoAtual"
                              color="error"
                              icon
                              small
                              @click="confirmDeleteItem(item)"
                              v-on="on"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para excluir o comportamento</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions>
        <v-row no-gutters>
          <div
            v-show="prazoAtual && usuarioMapeamento.tipo == 'REGULAR'"
            class="text-lg-right mt-3 mb-3"
          >
            <v-tooltip
              :disabled="!isCadastroFinalizado"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="!isCadastroFinalizado"
                  class="mr-2"
                  color="secondary"
                  outlined
                  @click="toogleDialogAgradecimento()"
                  v-on="on"
                >
                  Finalizar
                  <v-icon class="ml-2">
                    check
                  </v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para finalizar o cadastro dos
                comportamentos</span>
            </v-tooltip>
          </div>
        </v-row>
      </template>
    </app-mapeamento>

    <dialog-remove
      v-if="dialogs.remove"
      :confirm-action="excluir"
      :dialog-visible="dialogs.remove"
      :toogle-visible="toogleDialogRemove"
      descricao="Você realmente deseja excluir esse comportamento?"
    />

    <dialog-agradecimento
      :dialog-visible="dialogs.agradecimento"
      :toogle-visible="toogleDialogAgradecimento"
      :descricao="mensagemAgradecimento"
      url-redirecionamento="/mapeamento"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import AppAlert from '@/components/core/AppAlert';
import DialogRemove from '@/components/DialogRemove';
import AppMapeamento from '@/components/core/AppMapeamento';
import DialogAgradecimento from '@/components/DialogAgradecimento';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const comportamentosRepository = RepositoryFactory.get('comportamento');

export default {
  name: 'CadastroComportamental',

  components: {
    AppAlert,
    DialogRemove,
    AppMapeamento,
    DialogAgradecimento,
    InfoDispensa,
  },

  data() {
    return {
      headers: [
        { text: 'COMPORTAMENTOS', value: 'descricao', sortable: false },
        {
          sortable: false,
          value: 'acoes',
          width: '15%',
          align: 'end',
        },
      ],
      categorias: [
        {
          id: 'GOSTO',
          descricao: 'Gosto',
          icone: 'thumb_up',
          frases: [
            'De qual comportamento observado você gosta?',
            'Há mais algum comportamento observado que você goste?',
          ],
        },
        {
          id: 'NAO_GOSTO',
          descricao: 'Não gosto',
          icone: 'thumb_down',
          frases: [
            'De qual comportamento observado você não gosta?',
            'Há mais algum comportamento observado que você não goste?',
          ],
        },
        {
          id: 'IDEAL',
          descricao: 'O Ideal seria',
          icone: 'check_circle',
          frases: ['Qual comportamento seria ideal?', 'Há mais algum comportamento que você considere ser ideal?'],
        },
      ],
      categoria: '',
      comportamento: {
        id: null,
        descricao: '',
        categoria: '',
      },
      isEditando: false,
      dialogs: {
        remove: false,
        info: false,
        agradecimento: false,
      },
      mensagemAgradecimento:
        'Agradecemos pela sua colaboração! Você ainda poderá participar do Cadastro dos Comportamentos '
        + 'até o período estabelecido.',
    };
  },

  computed: {
    ...mapState({
      mapeamento: (state) => state.mapeamento.mapeamento,
      isTutorialExibido: (state) => state.tutorial.dados.cadastroComportamental,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
    }),
    ...mapGetters({
      isCadastroIniciado: 'comportamento/isCadastroIniciado',
      isCadastroFinalizado: 'comportamento/isCadastroFinalizado',
      totalComportamentosGosto: 'comportamento/getTotalComportamentosGosto',
      totalComportamentosNaoGosto: 'comportamento/getTotalComportamentosNaoGosto',
      totalComportamentosIdeal: 'comportamento/getTotalComportamentosIdeal',
    }),
    loaded: {
      get() {
        return this.$store.state.comportamento.loaded;
      },
      set(loaded) {
        this.$store.dispatch('comportamento/setLoaded', loaded);
      },
    },
    comportamentos: {
      get() {
        switch (this.categoria) {
          case 'GOSTO':
            return this.$store.state.comportamento.comportamentosGosto;
          case 'NAO_GOSTO':
            return this.$store.state.comportamento.comportamentosNaoGosto;
          case 'IDEAL':
            return this.$store.state.comportamento.comportamentosIdeal;
          default:
            return [];
        }
      },
      set(comportamentos) {
        const payload = { tipo: this.categoria, comportamentos };
        this.$store.dispatch('comportamento/setComportamentos', payload);
      },
    },
    frase() {
      if (this.categoria === 'GOSTO') {
        return this.totalComportamentosGosto.length > 0 ? this.categorias[0].frases[1] : this.categorias[0].frases[0];
      }
      if (this.categoria === 'NAO_GOSTO') {
        return this.totalComportamentosNaoGosto.length > 0
          ? this.categorias[1].frases[1]
          : this.categorias[1].frases[0];
      }
      if (this.categoria === 'IDEAL') {
        return this.totalComportamentosIdeal.length > 0 ? this.categorias[2].frases[1] : this.categorias[2].frases[0];
      }
      return '';
    },
    prazoAtual() {
      return !this.prazoEsgotado && !this.prazoFuturo;
    },
    prazoEsgotado() {
      return Data.compare('isAfter', { b: this.mapeamento.fimPerComportServidor });
    },
    prazoFuturo() {
      return Data.compare('isBefore', { b: this.mapeamento.inicioPerComportServidor });
    },
  },

  watch: {
    mapeamento() {
      this.loadComportamentos();
    },
    comportamentos() {
      this.clearFields();
    },
    categoria() {
      this.clearFields();
    },
  },

  created() {
    this.loadComportamentos();
  },

  methods: {
    loadComportamentos() {
      if (
        (this.loaded.mapeamento !== this.mapeamento.id || !this.loaded.status)
        && (this.prazoAtual || this.prazoEsgotado)
      ) {
        const payload = { mapeamento: this.mapeamento.id, comissao: false };
        this.$store.dispatch('comportamento/load', payload).then(() => {
          this.loaded.mapeamento = this.mapeamento.id;
          this.loaded.status = true;
          if (!this.isCadastroIniciado && !this.isTutorialExibido && this.prazoAtual) {
            this.$store.dispatch('app/showTutorial', { nome: 'CadastroComportamental' });
          }
        });
      }
    },
    salvar() {
      if (this.isEditando) {
        this.comportamento.categoria = this.categoria;
        comportamentosRepository.update(false, this.comportamento).then((res) => {
          const comportamento = res.data;
          if (comportamento.id) {
            const index = this.comportamentos.findIndex((c) => c.id === comportamento.id);
            if (index !== -1) {
              this.comportamentos.splice(index, 1, comportamento);
              this.$store.dispatch('app/success', { response: res, message: 'Comportamento atualizado com sucesso!' });
            }
          }
        });
      } else {
        this.comportamento.categoria = this.categoria;
        comportamentosRepository.create(this.mapeamento.id, this.comportamento).then((res) => {
          this.comportamentos.push(res.data);
          this.$store.dispatch('app/success', {
            response: res,
            message: 'Comportamento cadastrado com sucesso!',
          });
        });
      }
    },
    confirmDeleteItem(item) {
      this.clearFields();
      this.comportamento.id = item.id;
      this.toogleDialogRemove();
    },
    excluir() {
      comportamentosRepository.delete(this.comportamento.id).then((res) => {
        const index = this.comportamentos.findIndex((c) => c.id === this.comportamento.id);
        if (index !== -1) {
          this.comportamentos.splice(index, 1);
          this.$store.dispatch('app/success', { response: res, message: 'Comportamento excluído com sucesso!' });
        }
        this.toogleDialogRemove();
      });
    },
    getTotalComportamentos(categoria) {
      if (categoria === 'GOSTO') {
        return this.totalComportamentosGosto.toString();
      }
      if (categoria === 'NAO_GOSTO') {
        return this.totalComportamentosNaoGosto.toString();
      }
      if (categoria === 'IDEAL') {
        return this.totalComportamentosIdeal.toString();
      }
      return [];
    },
    clearFields() {
      this.comportamento.id = null;
      this.comportamento.descricao = '';
      this.isEditando = false;
    },
    prepararEdicao(item) {
      window.scrollTo({
        top: 180,
        left: 0,
        behavior: 'smooth',
      });
      this.isEditando = true;
      this.comportamento.id = item.id;
      this.comportamento.descricao = item.descricao;
    },
    toogleDialogRemove() {
      this.dialogs.remove = !this.dialogs.remove;
    },
    toogleDialogAgradecimento() {
      this.dialogs.agradecimento = !this.dialogs.agradecimento;
    },
  },
};
</script>
